import { db } from '../lib/db';
import { queueAction } from '../lib/sync';

const BASE_URL = process.env.REACT_APP_API_URL || '';
let isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
export function setOnlineStatusAsaas(online) { isOnline = online; }

function getToken() {
  return localStorage.getItem('token');
}

async function request(method, path, body = null) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`
    }
  };
  if (body) options.body = JSON.stringify(body);
  const res = await fetch(`${BASE_URL}${path}`, options);
  const data = await res.json();
  return data;
}

// Listar clientes Asaas (com paginação e filtro) - cache offline
export async function getAsaasClients(params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `/api/asaas/customers?${query}`;
  if (isOnline) {
    try {
      const result = await request('GET', url);
      if (result && result.data && Array.isArray(result.data)) {
        // Armazenar no IndexedDB com prefixo 'asaas_' para não conflitar
        await db.clients.bulkPut(result.data.map(c => ({ ...c, _source: 'asaas' })));
      }
      return result;
    } catch (err) {
      console.error('Erro online Asaas, tentando cache:', err);
    }
  }
  // Offline: busca local
  const clients = await db.clients.where('_source').equals('asaas').toArray();
  return { data: clients };
}

export async function getAsaasClientById(id) {
  if (isOnline) {
    try {
      const client = await request('GET', `/api/asaas/customers/${id}`);
      await db.clients.put({ ...client, _source: 'asaas' });
      return client;
    } catch (err) {
      console.error('Erro online, tentando cache:', err);
    }
  }
  return db.clients.get(id);
}

// Criar cliente Asaas só online
export async function createAsaasClient(dados) {
  if (!isOnline) throw new Error('Criação de cliente Asaas requer conexão');
  const result = await request('POST', '/api/asaas/customers', dados);
  await db.clients.put({ ...result, _source: 'asaas' });
  return result;
}

export async function getAsaasPayments(customerId) {
  const url = `/api/asaas/local-payments?asaas_customer_id=${customerId}`;
  if (isOnline) {
    try {
      const response = await request('GET', url);
      const payments = Array.isArray(response) ? response : (response?.data || []);
      await db.payments.bulkPut(payments.map(p => ({ ...p, client_id: customerId, _source: 'asaas' })));
      return payments;
    } catch (err) {
      console.error('Erro online, tentando cache:', err);
    }
  }
  // Offline: busca local
  const local = await db.payments.where({ client_id: customerId, _source: 'asaas' }).toArray();
  return local;
}

export async function updateAsaasClient(id, dados) {
  if (!isOnline) throw new Error('Atualização de cliente Asaas requer conexão');
  const result = await request('PUT', `/api/asaas/customers/${id}`, dados);
  await db.clients.put({ ...result, _source: 'asaas' });
  return result;
}

export async function getAsaasPaymentById(paymentId) {
  if (!isOnline) throw new Error('Consulta de pagamento Asaas requer conexão');
  return request('GET', `/api/asaas/payments/${paymentId}`);
}

export function getAsaasPaymentPdfUrl(paymentId) {
  return `${BASE_URL}/api/asaas/payments/${paymentId}/pdf`;
}

export async function createAsaasPayment(paymentData) {
  if (!isOnline) throw new Error('Criação de pagamento Asaas requer conexão');
  return request('POST', `/api/asaas/payments`, paymentData);
}
